import Vue from 'vue';
import Router from 'vue-router';
import Dashboard from '../components/Views/Dashboard';
import Viewer from '../components/Views/Viewer';
import Models from '../components/Views/Models';
import Companion from '../components/Views/Companion';
import CompanionModels from '../components/Views/CompanionModels';
import Brochures from '../components/Views/Brochures';
import WebAR from '../components/Views/WebAR';
import WebARModels from '../components/Views/WebARModels';
import WebAREmbeds from '../components/Views/WebAREmbeds';
import Subscriptions from '../components/Views/Subscriptions';
import Checkout from '../components/Views/Checkout';
import PaymentResult from '../components/Views/PaymentResult';
import Support from '../components/Views/Support';
 
Vue.use(Router);
 
export default new Router({
  linkExactActiveClass: 'active',
  routes: [
    {
      path: '/',
      name: 'Dashboard',
      component: Dashboard
    },
    {
      path: '/Viewer',
      name: 'Viewer',
      component: Viewer
    },
    {
      path: '/Models',
      name: 'Models',
      component: Models
    },
    {
      path: '/Companion',
      name: 'Companion',
      component: Companion
    },
    {
      path: '/Companion/Models',
      name: 'CompanionModels',
      component: CompanionModels
    },
    {
      path: '/Companion/Brochures',
      name: 'Brochures',
      component: Brochures
    },
    {
      path: '/WebAR',
      name: 'WebAR',
      component: WebAR
    },
    {
      path: '/WebAR/Models',
      name: 'WebARModels',
      component: WebARModels
    },
    {
      path: '/WebAR/Embeds',
      name: 'WebAREmbeds',
      component: WebAREmbeds
    },
    {
      path: '/Subscription',
      name: 'Subscription',
      component: Subscriptions
    },
    {
      path: '/Checkout',
      name: 'Checkout',
      component: Checkout
    },
    {
      path: '/Payment/:status',
      name: 'Payment',
      component: PaymentResult
    },
    {
      path: '/Support',
      name: 'Support',
      component: Support
    }
  ]
});
